import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './SideMenu.css';

const SideMenu = ({ isOpen, toggleMenu, darkMode }) => {
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    toggleMenu();
    navigate('/login');
  };

  const handleNavigation = (path) => {
    toggleMenu();
    navigate(path);
  };

  console.log("SideMenu rendered, isOpen:", isOpen);

  // Log the dark mode state for debugging
  console.log("SideMenu darkMode:", darkMode);
  console.log("Document has dark-theme class:", document.documentElement.classList.contains('dark-theme'));

  return (
    <>
      <div
        className={`side-menu-overlay ${isOpen ? 'active' : ''} ${darkMode ? 'dark-overlay' : ''}`}
        onClick={toggleMenu}
        style={darkMode ? { backgroundColor: 'rgba(0, 0, 0, 0.7)' } : {}}
      ></div>
      <div
        className={`side-menu ${isOpen ? 'open' : ''} ${darkMode ? 'dark-mode dark-theme' : ''}`}
        style={{
          zIndex: 1050,
          ...(darkMode ? {
            backgroundColor: '#121212',
            color: '#f8f9fa',
            boxShadow: '0 0 20px rgba(0, 0, 0, 0.7)'
          } : {})
        }}
        data-theme={darkMode ? 'dark' : 'light'}
        data-bs-theme={darkMode ? 'dark' : 'light'}
      >
        <div className="side-menu-header" style={darkMode ? {
          borderBottomColor: 'rgba(255, 255, 255, 0.1)',
          backgroundColor: '#1e1e1e'
        } : {}}>
          <h3 style={darkMode ? { color: '#ffffff', textShadow: '0 0 10px rgba(255, 255, 255, 0.2)' } : {}}>StoryCape</h3>
          <button className="close-btn" onClick={toggleMenu} style={darkMode ? { color: '#f8f9fa' } : {}}>
            ✕
          </button>
        </div>
        <div className="side-menu-content" style={darkMode ? { color: '#e0e0e0' } : {}}>
          {isAuthenticated ? (
            <ul className="side-menu-nav">
              <li className="side-menu-item">
                <button
                  onClick={() => handleNavigation('/stories')}
                  className="side-menu-link"
                  style={darkMode ? { color: '#e0e0e0' } : {}}
                >
                  <span className="icon me-2" style={darkMode ? { color: '#3b82f6', textShadow: '0 0 5px rgba(59, 130, 246, 0.7)' } : {}}>📚</span>
                  Stories
                </button>
              </li>
              <li className="side-menu-item">
                <button
                  onClick={() => handleNavigation('/create-story')}
                  className="side-menu-link"
                  style={darkMode ? { color: '#e0e0e0' } : {}}
                >
                  <span className="icon me-2" style={darkMode ? { color: '#3b82f6', textShadow: '0 0 5px rgba(59, 130, 246, 0.7)' } : {}}>➕</span>
                  Create New Story
                </button>
              </li>
              <li className="side-menu-item">
                <button
                  onClick={() => handleNavigation('/apps')}
                  className="side-menu-link"
                  style={darkMode ? { color: '#e0e0e0' } : {}}
                >
                  <span className="icon me-2" style={darkMode ? { color: '#3b82f6', textShadow: '0 0 5px rgba(59, 130, 246, 0.7)' } : {}}>🔲</span>
                  Manage Apps
                </button>
              </li>
              <li className="side-menu-divider" style={darkMode ? { backgroundColor: 'rgba(255, 255, 255, 0.1)' } : {}}></li>
              <li className="side-menu-item">
                <button
                  onClick={handleLogout}
                  className="side-menu-link text-danger"
                  style={darkMode ? { color: '#f87171' } : {}}
                >
                  <span className="icon me-2" style={darkMode ? { color: '#f87171', textShadow: '0 0 5px rgba(239, 68, 68, 0.7)' } : {}}>🚪</span>
                  Logout
                </button>
              </li>
            </ul>
          ) : (
            <ul className="side-menu-nav">
              <li className="side-menu-item">
                <button
                  onClick={() => handleNavigation('/login')}
                  className="side-menu-link"
                  style={darkMode ? { color: '#e0e0e0' } : {}}
                >
                  <span className="icon me-2" style={darkMode ? { color: '#3b82f6', textShadow: '0 0 5px rgba(59, 130, 246, 0.7)' } : {}}>🔑</span>
                  Login
                </button>
              </li>
            </ul>
          )}
        </div>
        <div className="side-menu-footer" style={darkMode ? {
          borderTopColor: 'rgba(255, 255, 255, 0.1)',
          color: '#a0a0a0',
          backgroundColor: '#1e1e1e'
        } : {}}>
          <p>© {new Date().getFullYear()} StoryCape</p>
        </div>
      </div>
    </>
  );
};

export default SideMenu;